// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/view/settings/Menu2/Item.css
// module id = 2034
// module chunks = 0